import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import fingerprintReducer from "../slices/fingerprintSlice";
import recaptchaReducer from "../slices/recaptchaSlice";
import rewardReducers from "../slices/rewardSlice";
import appReducers from "../slices/appSlice";
import remittanceSlice from "../slices/remittanceSlice";
import accountMergeReducer from "../slices/accountMergeSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    fingerprint: fingerprintReducer,
    recaptcha: recaptchaReducer,
    reward: rewardReducers,
    app: appReducers,
    remittance: remittanceSlice,
    accountMerge: accountMergeReducer,
  },
  devTools: process.env.REACT_APP_ENV === "production" ? false : true,
});

export default store;
